/**
 * Check if HTML content has images without alt attributes
 * @param {string} htmlContent - HTML content to check
 * @returns {boolean} - true if there are images without alt attribute
 */
export const hasImagesWithoutAlt = (htmlContent) => {
  if (!htmlContent) return false;

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');
  const images = doc.querySelectorAll('img');

  for (let img of images) {
    if (!img.getAttribute('alt') || img.getAttribute('alt').trim() === '') {
      return true;
    }
  }

  return false;
};

/**
 * Check if either SK or EN content has images without alt
 * @param {object} formValues - Form values with content_sk and content_en
 * @returns {boolean} - true if any content has images without alt
 */
export const checkIfAltAttributesMissing = (formValues) => {
  const skHasMissing = hasImagesWithoutAlt(formValues.content_sk);
  const enHasMissing = hasImagesWithoutAlt(formValues.content_en);

  return skHasMissing || enHasMissing;
};

/**
 * Add alt attribute to all images in HTML content
 * @param {string} htmlContent - HTML content
 * @param {string} altText - Text to use for alt attribute
 * @returns {string} - Modified HTML content
 */
export const addAltAttributesToImages = (htmlContent, altText) => {
  if (!htmlContent || !altText) return htmlContent;

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');
  const images = doc.querySelectorAll('img');

  let modified = false;
  images.forEach((img) => {
    const currentAlt = img.getAttribute('alt');
    if (!currentAlt || currentAlt.trim() === '') {
      img.setAttribute('alt', altText);
      modified = true;
    }
  });

   if (!modified) return htmlContent;

   // Get the modified HTML from body children
   return Array.from(doc.body.childNodes)
     .map(node => {
       if (node.nodeType === Node.TEXT_NODE) {
         return node.textContent;
       }
       return node.outerHTML;
     })
     .join('');
};

/**
 * Update form values with alt attributes added
 * @param {object} formValues - Original form values
 * @param {string} skTitle - Slovak title for SK content alt text
 * @param {string} enTitle - English title for EN content alt text
 * @returns {object} - Updated form values
 */
export const addAltAttributestoFormContent = (formValues, skTitle, enTitle) => {
  const updatedValues = { ...formValues };

  if (formValues.content_sk && skTitle) {
    const hasSkMissing = hasImagesWithoutAlt(formValues.content_sk);
    if (hasSkMissing) {
      updatedValues.content_sk = addAltAttributesToImages(formValues.content_sk, skTitle);
    }
  }

  if (formValues.content_en && enTitle) {
    const hasEnMissing = hasImagesWithoutAlt(formValues.content_en);
    if (hasEnMissing) {
      updatedValues.content_en = addAltAttributesToImages(formValues.content_en, enTitle);
    }
  }

  return updatedValues;
};

